import IconMenuButton from 'apollo-react/components/IconMenuButton/IconMenuButton';
import Tooltip from 'apollo-react/components/Tooltip/Tooltip';
import EllipsisHorizontal from 'apollo-react-icons/EllipsisHorizontal';
import StarSolid from 'apollo-react-icons/StarSolid';
import classNames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleFavorite } from '../../../actions/FavoritesActions';
import * as Urls from '../../../constants/Urls';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import Loader from '../../CustomLoader';
import Link from '../../Link';

const Favorites = ({ classes, closeDrawer }) => {
  const favorites = useSelector((state) => state.favorites);
  const dispatch = useDispatch();
  const translateString = useTranslation();

  if (favorites.loading) {
    return <Loader />;
  }

  const handleDelete = (favorite) => {
    dispatch(
      toggleFavorite({
        virtualFilePath: favorite.VirtualFilePath,
        entityType: favorite.EntityType,
        entityKey: favorite.EntityKey,
        queryString: favorite.QueryString,
      })
    );
  };

  const menuItems = (favorite) => [
    {
      text: translateString('Delete'),
      onClick: () => handleDelete(favorite),
    },
  ];

  return (
    <div className={classes.drawerSubgroups}>
      <ul className={classes.drawerGroup}>
        {favorites.data.length === 0 && <p>{translateString('No favorite records yet')}</p>}
        {favorites.data.map((favorite) => (
          <li key={favorite.EntityKey} ui-ta={`Event${favorite.EntityKey}`}>
            <div className={classes.itemContainer}>
              <Link
                className={classNames(classes.drawerLink, classes.favoriteLink)}
                onClick={closeDrawer}
                to={{ pathname: Urls.ENTITY_DISPLAY, search: `${favorite.QueryString}` }}
              >
                <StarSolid className={classes.favoriteIcon} fontSize="small" />
                {favorite.EntityKey}
              </Link>
              <Tooltip title={translateString('Actions')} disableFocusListener>
                <IconMenuButton id="actions" menuItems={menuItems(favorite)} size="small">
                  <EllipsisHorizontal />
                </IconMenuButton>
              </Tooltip>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Favorites;
